module.exports = __webpack_public_path__ + "static/media/eye-close-purple.b00b85e0.svg";